import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const WaterfallSummaryTable = () => {
  const actionsButtons = ["export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="report/waterfall-summary"
    onClickModalContent={(_, { clickedRowData }) => {
      return (
        <LmsTable
          actionButtons={["export"]}
          apiSuffix={`report/waterfall-summary/details/${clickedRowData?.id}`}
          skipClick
        />
      );
    }}
    onClickModalSize="fullscreen"
  />;
};

const LmsReportsWaterfallSummary = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }
  return (<WaterfallSummaryTable />);
};

export default LmsReportsWaterfallSummary;